import React from 'react'
import { usePracticeInterviewing } from './PracticeInterviewingProvider'
import { Button } from '~/lib/ui/button'
import PartOneForm from './PartOneForm'
import PartTwoForm from './PartTwoForm'
import { useTranslation } from '../../hooks/useTranslation'

const PracticeInterviewForm = () => {
  const {
    formIndex,
    setFormIndex,
    setShowForm,
    practice_interview_images,
    generatePracticeInterview,
    disableContinue,
  } = usePracticeInterviewing()
  const { t } = useTranslation('PracticeInterviewForm')
  return (
    <div className="flex w-full flex-col rounded-2xl bg-lily-blue px-4 py-8 text-primary md:m-8 md:flex-row">
      <div className="md:w-1/2">
        {formIndex === 0 && <PartOneForm />}
        {formIndex === 1 && <PartTwoForm />}
      </div>
      <div className="md:w-1/2">
        {formIndex === 0 && (
          <div className="flex h-full w-full flex-col">
            <div className="m-auto h-2/3 w-2/3">
              <img src={practice_interview_images[0]} />
            </div>
            <div className="w-full text-center md:text-right">
              <Button
                onClick={() => setShowForm(false)}
                className="mr-8 !border-[#2F2F2F] bg-white text-[#2F2F2F] hover:!bg-accent  hover:text-[#2F2F2F] focus:border-accent focus:bg-accent focus:text-[#2F2F2F] active:border-accent active:bg-accent active:text-[#2F2F2F]"
              >
                {t('back')}
              </Button>
              <Button
                disabled={disableContinue}
                onClick={() => setFormIndex(1)}
              >
                {t('continue')}
              </Button>
            </div>
          </div>
        )}
        {formIndex === 1 && (
          <div className="flex h-full w-full flex-col">
            <div className="m-auto h-1/2 w-1/2">
              <img src={practice_interview_images[1]} />
            </div>
            <div className="w-full text-right">
              <Button
                onClick={() => setFormIndex(0)}
                className="mr-8 !border-[#2F2F2F] bg-white text-[#2F2F2F] hover:!bg-accent  hover:text-[#2F2F2F] focus:border-accent focus:bg-accent focus:text-[#2F2F2F] active:border-accent active:bg-accent active:text-[#2F2F2F]"
              >
                {t('back')}
              </Button>
              <Button onClick={() => generatePracticeInterview()}>
                {t('generate_interview')}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PracticeInterviewForm
